<template lang="pug">
  #QRCode.container-width
    .p-3.text-center(
      v-if="data"
    )
      .mb-3.mt-3
        ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
          :profileUrl="data.picture_url",
          :style="{ 'width': '150px', 'height': '150px' }"
        )
      h5.mb-3 {{ data.chinese_last_name }} {{ data.chinese_first_name }}
      vue-qr(
        v-if="data",
        :text="`${ bindSaRouter }?sa_id=${ data.id ? data.id : null }&store_id=${ nowSelectStore ? nowSelectStore.id : null }`"
      )
      small.d-block.m-0 請掃描 QR-code
      small.d-block.mb-3 尊享 {{ $companyName }} 專屬顧問服務
      .underThanTwoStore(
        v-if="data.stores.length <= 2"
      )
        b-row(
          :no-gutters="data.stores.length === 2"
        )
          b-col(
            :cols="data.stores.length === 2 ? 6 : 12",
            v-for="(store,index) in data.stores",
            :key="store.id",
            :class="{ 'text-right pr-1': data.stores.length === 2 && index === 0, 'text-left pl-1': data.stores.length === 2 && index === 1 }"
          )
            b-button(
              variant="primary",
              @click="changeQRCodeHandler(store)"
            ) {{ store.store_dealer_title }}/{{ store.title }}
      .moreThanTwoStore
        b-select(
          v-if="data.stores.length > 2"
          :option="stores",
          v-model="nowSelectStore"
        )
          b-form-select-option(
            v-for="(store,index) in data.stores",
            :key="store",
            :value="store"
          ) {{ store.store_dealer_title }}/{{ store.title }}
</template>

<script>
import { mapState } from 'vuex';
import VueQr from 'vue-qr';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';

export default {
  name: 'QRCodeIndex',
  components: {
    ProfilePhotoSticker,
    VueQr
  },
  data() {
    return {
      nowSelectStore: null
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    // 取得個人資料
    vm.$store.dispatch('sm_qr_code/getProfileHandler')
      .then(() => {
        vm.nowSelectStore = vm.data.stores[0] ? vm.data.stores[0] : null;
        vm.$swal.close();
        vm.$store.commit('toggleLoading', false);
      });
  },
  methods: {
    changeQRCodeHandler(store) {
      const vm = this;
      if (store === vm.nowSelectStore) return;
      vm.nowSelectStore = store;
    }
  },
  computed: {
    ...mapState({
      data: (state) => state.sm_qr_code.data
    }),
    bindSaRouter() {
      if (process.env.NODE_ENV === 'development') {
        return `${process.env.VUE_APP_DOMAIN}:${process.env.VUE_APP_DEV_PORT}/member/bind-sa`;
      }
      return `${process.env.VUE_APP_DOMAIN}/member/bind-sa`;
    }
  }
};
</script>

<style>

</style>
